import { render, staticRenderFns } from "./ChangeName.vue?vue&type=template&id=0b9f9fe4&scoped=true"
import script from "./ChangeName.vue?vue&type=script&lang=js"
export * from "./ChangeName.vue?vue&type=script&lang=js"
import style0 from "./ChangeName.vue?vue&type=style&index=0&id=0b9f9fe4&prod&lang=scss&scoped=true"
import style1 from "./ChangeName.vue?vue&type=style&index=1&id=0b9f9fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f9fe4",
  null
  
)

export default component.exports